import React from 'react';
import LocationTemplate from './LocationTemplate';

const SanfordPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Sanford"
      stateName="North Carolina"
      countyName="Lee"
      zipCodes={["27330", "27331", "27332"]}
      latitude={35.4798}
      longitude={-79.1809}
      population={30085}
      historicalFact="Named after C.O. Sanford, a railroad civil engineer; established in 1872."
      nearbyTowns={[
        "Fayetteville, NC",
        "Raleigh, NC",
        "Chapel Hill, NC",
        "Durham, NC",
        "Pittsboro, NC",
        "Apex, NC",
        "Cary, NC",
        "Southern Pines, NC"
      ]}
    />
  );
};

export default SanfordPage;